import { Outlet, generatePath } from 'react-router-dom';

import { Navigate } from '@sorare/routing';

import { NewPageHeader } from '@sorare/core/src/components/navigation/NewPageHeader';
import { MLB_SCOUTING_CENTER_STATS } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';

const ScoutingCenterWatchlistsLayout = () => {
  const {
    flags: { useWatchlists = false },
  } = useFeatureFlags();

  if (!useWatchlists)
    return <Navigate to={generatePath(MLB_SCOUTING_CENTER_STATS)} />;
  return (
    <>
      <NewPageHeader text={scoutingCenter.myWatchlists} disableBackBrowser />
      <Outlet />
    </>
  );
};

export default ScoutingCenterWatchlistsLayout;
